import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {DeviceViewModel} from "../../../models/device.view-model";
import {DIRECTIONS} from "../carousel.consts";
import classNames from "classnames";
import styles from "../styles/carousel.module.scss"

export class CarouselContainerProps extends BaseProps {
  isSmallView: Boolean;
  isRtl: Boolean;
  sliding: Boolean;
  direction: DIRECTIONS;
  device: DeviceViewModel;
}

export const CarouselContainer = (props: CarouselContainerProps) => {
  const direction = props.isRtl ? '100%' : '-100%';

  const containerProps = {
    style: {
      transition: props.sliding ? `none` : `transform 300ms ease`,
      transform: !props.sliding ? `translateX(${direction})` : (props.direction === DIRECTIONS.previous ? `translateX(calc(2 * (${direction})))` : `translateX(0%)`),
    },
    className: classNames(styles.items_container),
  };

  return (
    <div {...containerProps}>
      {props.children}
    </div>
  )
};
